import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { LoaderService } from 'src/app/services/loader.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  defImgProd: string = "assets/logos-nina/nina2_placeholder_cuadrado.jpg";
  defImgLinea: string = "assets/logos-nina/nina2_placeholder_cuadrado.jpg";
  defImgBanner: string = "assets/logos-nina/nina2_placeholder_banner2.jpg";
  lines: any = [];
  banners: any = [];
  cookieBranch: any = {}
  tokenSSLoged: boolean = false
  userData: any = { id: 0 };
  @ViewChild('linesSlider')
  linesSlider!: ElementRef<HTMLDivElement>;

  customOptions: OwlOptions = {
    loop: true,
    autoHeight: false,
    autoWidth: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    autoplay: true,
    navSpeed: 5000,
    responsiveRefreshRate: 1000,
    navText: [
      '<i class="fa-chevron-left"></i>',
      '<i class="fa-chevron-right"></i>'
    ],
    responsive: {
      0: {
        items: 1
      }
    },
    nav: false
  }

  constructor(private loaderService: LoaderService, public apiServices: ApiService, public cookies: CookieService, public router: Router, private coreService: CoreService, public apiUsersServices: UsersService) {
    this.tokenSSLoged = this.cookies.check('UL')
    if (this.tokenSSLoged) {
      this.getDataProfile()
    }
  }

  ngOnInit(): void {
    this.getLineas()
    this.getBanners()

    this.coreService.emitSubjet.subscribe(response => {
      if (response.type === 'PromoBanner') {
        // console.log("Click en Banner", response)
        this.goToPromo(response.payload.idPromo, response.payload.tipoPromo)
      }
    });
  }


  getData(data: SlidesOutputData) {

  }

  getDataProfile() {
    this.loaderService.show()
    this.apiUsersServices.me().subscribe({
      next: (value) => {
        // console.log(value)
        this.loaderService.hide()
        if (value.status) {
          this.userData = value.data
        }
        else {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        }
      },
      error: (err) => {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        console.error(err)
        this.loaderService.hide()
      },
    })
  }

  getBanners() {
    this.loaderService.show()
    let data = { token: this.cookies.get('Token') }
    this.apiServices.getBanners(data).subscribe({
      next: (value) => {
        // console.log(value)
        this.banners = value;
        this.loaderService.hide()
      },
      error: (err) => {
        // console.log(err)
        this.loaderService.hide()
        this.cookies.deleteAll()
        location.reload()
      }
    })
  }

  scrollLines(direction: 'left' | 'right') {
    const slider = this.linesSlider.nativeElement;
    const amount = 400;
    slider.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth'
    });
  }

  goToBanner(selectedBanner: any) {
    let checkSession = this.cookies.check('UL')
    if (selectedBanner.idPromocion == 0) {
      if (selectedBanner.link) {
        window.open(selectedBanner.urlLink, '_blank');
      }
    }
    else {
      if (selectedBanner.idPromocion && selectedBanner.tipoPromo) {
        if (selectedBanner.idPromocion > 0 && selectedBanner.tipoPromo > 0) {
          // console.log("InBanner",selectedBanner)
          this.goToPromo(selectedBanner.idPromocion, selectedBanner.tipoPromo)
        }
      }
    }

  }

  goToPromo(idPromo: any, tipoPromo: any) {
    let promocion = { idPromo: idPromo, tipoPromo: tipoPromo }
    // console.log(promocion)
    this.tokenSSLoged = this.cookies.check('UL')
    if (this.tokenSSLoged === null) {
      this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Inicia sesión para ver los detalles de la promoción" } });
      return;
    }
    else {
      this.cookieBranch = null
      if (this.cookies.check('Branch')) {
        this.cookieBranch = JSON.parse(this.cookies.get('Branch'))
      }
      else if (this.cookies.check('BranchTemp')) {
        this.cookieBranch = JSON.parse(this.cookies.get('BranchTemp'))
      }
      this.cookies.set('DataPromo', JSON.stringify({ idPromo: idPromo, idCliente: this.userData.id, tipoPromo: tipoPromo }), { path: '/' });
      if (this.tokenSSLoged) {
        if (this.cookieBranch != null) {
          if (tipoPromo == 1) {
            this.router.navigate(['/promo1'])
          }
          else if (tipoPromo == 2) {
            this.router.navigate(['/promo2'])
          }
          else if (tipoPromo == 3) {
            this.router.navigate(['/promo3'])
          }
          else if (tipoPromo == 4) {
            this.router.navigate(['/promo4'])
          }
          else if (tipoPromo == 5) {
            this.router.navigate(['/promo5'])
          }
          else if (tipoPromo == 6) {
            this.router.navigate(['/promo6'])
          }
          else {
            this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Tipo de promoción no reconocido" } });
          }
        }
        else {
          this.coreService.emitSubjet.next({ type: 'ShippingType', payload: { promotion: promocion, user: this.userData } });
        }
      }
      else {
        this.coreService.emitSubjet.next({ type: 'LoginExternal', payload: null });
      }
    }
  }

  getLineas() {
    if (this.cookies.get("Branch")) {
      this.cookieBranch = JSON.parse(this.cookies.get("Branch"))
      let data = { token: this.cookies.get('Token'), idSucursal: this.cookieBranch.idSucursal }
      this.loaderService.show()
      this.apiServices.getLineasSucursal(data).subscribe({
        next: (value) => {
          this.lines = value;
          this.loaderService.hide()
        },
        error: (err) => {
          // console.log(err)
          this.loaderService.hide()
        }
      })
    }
    else {
      this.loaderService.show()
      let data = { token: this.cookies.get('Token') }
      this.apiServices.getLineas(data).subscribe({
        next: (value) => {
          this.lines = value;
          this.loaderService.hide()
        },
        error: (err) => {
          // console.log(err)
          this.loaderService.hide()
        }
      })
    }
  }

  selectedLine(selectedLine: any) {
    this.router.navigate(['/store'], { queryParams: { line: selectedLine.idLineaApp } })
  }

  goToCatalog() {
    this.router.navigate(['/store']);
  }
}
